import React from "react";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "src/hooks/useDebounce";

const SearchInput = ({ name, placeholder, error }) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const handleSearch = useDebounce((term) => {
		const newSearchParams = new URLSearchParams(searchParams);
		newSearchParams.set("page", "1");
		term ? newSearchParams.set(name, term) : newSearchParams.delete(name);
		setSearchParams(newSearchParams);
	}, 1000);

	return (
		<>
			<input
				id={name}
				name={name}
				type="search"
				placeholder={placeholder}
				onChange={(event) => handleSearch(event.target.value.trim())}
				defaultValue={searchParams.get(name) || ""}
				className="search-input !tw-min-w-[300px]"
			/>
			{error && <p className="errorMsg">{error}</p>}
		</>
	);
};

export default SearchInput;
